@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.stock-reorder.stockreorders' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
	</div>
</div>

<div class="table-wrapper">
	<table mat-table recycleRows [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
		<ng-container matColumnDef="title">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.stock-reorder.title' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.title }}</td>
		</ng-container>

		<ng-container matColumnDef="batch">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.stock-reorder.batch' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.batch }}</td>
		</ng-container>

		<ng-container matColumnDef="terminal">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.stock-reorder.terminal' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.terminal }}</td>
		</ng-container>

		<ng-container matColumnDef="reorderPartNumber">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.stock-reorder.reordered-part-number' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.reorderPartNumber }}</td>
		</ng-container>

		<ng-container matColumnDef="handled">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">
				{{ 'mes.stock-reorder.handled' | translate }}
			</th>
			<td mat-cell *matCellDef="let element" style="text-align: center">
				<mat-icon (click)="toggleHandled(element.stockReorder)" svgIcon="{{ element.handled ? 'acies_true' : 'acies_false' }}" [ngClass]="[element.handled ? 'greenColor' : 'redColor', 'clickable']"></mat-icon>
			</td>
		</ng-container>

		<ng-container matColumnDef="menu">
			<th mat-header-cell *matHeaderCellDef style="text-align: end"></th>
			<td mat-cell *matCellDef="let row" style="text-align: end">
				<button mat-icon-button [matMenuTriggerFor]="menu">
					<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button mat-menu-item (click)="openEdit(row.stockReorder)">
						<span>{{ 'mes.stock-reorder.buttons.editbtn' | translate }}</span>
					</button>
					<button mat-menu-item (click)="openDelete(row.stockReorder)">
						<span>{{ 'mes.stock-reorder.buttons.deletebtn' | translate }}</span>
					</button>
				</mat-menu>
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
